module.exports = __webpack_public_path__ + "static/media/oneday_7.ae4f94c0.png";